import { toSlug, SCOPES } from '../../../../../_shared';

class MentionView {

	/**
	 * Renders the final HTML content for the ProseMirror at-mention node.
	 *
	 * @param {object} node          The at-mention node.
	 * @param {object} view          The editor view.
	 *
	 * @param {object} mentionUsers  	The users that are available to at-mention.
	 * @param {string} scope         	The scope of the at-mention.
	 * @param {string} scopeId       	The scope ID of the at-mention.
	 * @param {function} onMentionClick	The click handler to trigger the user modal for at mentions.
	 */
	constructor(node, view, mentionUsers, scope, scopeId, onMentionClick) {

		this.node = node;
		this.view = view;

		// Get the data stored on the PM mention node
		const { id, username } = node.attrs;

		// Get the data for the mentioned user
		const user = mentionUsers[id];

		// If the user exists, make sure we're using the most
		// up-to-date version of the display name
		const displayName = user?.display_name || username;

		// Build the profile URL for the user
		let url = `/members/${toSlug(displayName, id)}`;

		if (scope === SCOPES.SESSION && scopeId) {
			url = `${url}?session_id=${scopeId}`;
		}

		this.dom = document.createElement('span');
		this.dom.setAttribute('data-mention-id', id);

		const linkDom = document.createElement('a');

		if (onMentionClick) {

			linkDom.addEventListener('click', (event) => onMentionClick(event, id));

		}

		linkDom.setAttribute('id', id);
		linkDom.setAttribute('href', url);
		linkDom.setAttribute('target', '_blank');
		linkDom.setAttribute('rel', 'noopener noreferrer nofollow');
		linkDom.setAttribute('aria-describedby', 'user-mention-tooltip');

		const textContent = document.createTextNode(`@${displayName}`);

		linkDom.appendChild(textContent);

		this.dom.appendChild(linkDom);

		const showTooltip = () => {

			const { tr } = view.state;

			tr.setMeta('mentionNode', this.node);
			tr.setMeta('mentionDOM', this.dom);

			view.dispatch(tr);

		};

		const hideTooltip = () => {

			const { tr } = view.state;

			tr.setMeta('mentionNode', null);
			tr.setMeta('mentionDOM', null);

			view.dispatch(tr);

		};

		this.dom.addEventListener('mouseover', showTooltip);
		linkDom.addEventListener('focus', showTooltip);

		this.dom.addEventListener('mouseout', hideTooltip);
		linkDom.addEventListener('blur', hideTooltip);

	}

}

export default MentionView;
